import React from 'react';

/** Approved Classic serving: oval plate with protein and greens. */
export default function ClassicServingIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 14c-1 .8-1.5 1.6-1.5 2.5C1.5 19 6.2 21 12 21s10.5-2 10.5-4.5c0-.9-.5-1.7-1.5-2.5M3 16c2 2 16 2 18 0" />
    <path d="M5 14c-1-2-.5-5 2-6 2-1 5 0 6 2l1 4c-2 2-7 2-9 0ZM8 10l3 3M7 12l2 2" />
    <path d="M15 14c-2-2-1-4 1-4-1-3 2-4 3-2 3-1 4 3 1 4l-1 2Z" />
  </svg>;
}
